import { FC } from 'react'
import cx from 'classnames'
import Styles from './Toolbar.module.scss'

export const Toolbar: FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={cx(Styles.toolbar, className)}>{children}</div>
)
